<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <RequestVehicle />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import RequestVehicle from "./components/RequestVehicle";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    RequestVehicle,
    // ProjectsTable,
  },
};
</script>
